import { registerPageView, registerPV } from '@/plugins/helper'

export default function() {
  registerPageView()
  registerPV()
}
